import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { CommonService } from './services/common.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'anyspace';

  /**
   * @param  {HttpClient} http - HttpClient object
   */
  constructor(private http: HttpClient) {
    CommonService.http = http;
  }
}
